// Routing-only registry - used by App.tsx for React Router setup and as a
// loading-state fallback in resolvePortalConfig before the API responds.
// Full label/column/card definitions live in the backend (packages/common/src/constants/portalRegistry.ts)
// and are served via GET /me/portal-config as the `registry` field.
export interface PageRoute {
  id: string;
  path: string;
  iconName?: string;
}

export const PAGE_ROUTE_REGISTRY: PageRoute[] = [
  { id: 'dashboard', path: '/', iconName: 'BarChart3' },
  { id: 'transactions', path: '/transactions', iconName: 'FileText' },
  { id: 'information', path: '/information', iconName: 'Info' },
];
